<div class="wrapper">
  <!-- <div class="cc-modal-table-search">
     <div class="cc-modal-table-cell-search">
       <h3 *ngIf="title" fxLayout="row" fxLayoutAlign="start center" class="component-heading">
         {{title}}
         <span *ngIf="!isRadioSelector" style="margin-left: 3px">
         ({{selectionCount}})
       </span>
         <div *ngIf="eventAdderTitle"  class="m-l-10" fxLayout="row" fxLayoutAlign="start center">
           (<a (click)="onEvent()" class="link-button pointer">{{eventAdderTitle}}</a>)
         </div>
       </h3>
       <div fxLayoutAlign="center center" class="tiny-selector-container">
         <span class="selector-label">Sort:</span>
         <mat-form-field class="no-placeholder-animation tiny-selector">
           <mat-select [(value)]="selectedSortOption" (selectionChange)="onSelectionChange()">
             <mat-option *ngFor="let option of sortOptions"
                         [value]="option.value">
               {{option.title}}
             </mat-option>
           </mat-select>
         </mat-form-field>
       </div>
     </div>
     <div class="cc-modal-table-cell-search ">
       <form [formGroup]="Form" fxFlex="1 0 auto">
         <mat-form-field class="orbitax-search-field" appearance="outline" fxFlex="100">
           <mat-label>Search</mat-label>
           <input particleAnalytics
                  analyticsCategory="tree-selector-search"
                  analyticsAction="search"
                  [analyticsName]="searchText" formControlName="search" matInput placeholder="Search your items"
                  [(ngModel)]="searchText">
         </mat-form-field>
       </form>
     </div>
   </div>-->
  <div class="cc-modal-table">
    <div class="cc-modal-table-cell">
      <h3 class="component-heading ">Contacts</h3>
      <div [formGroup]="filterForm">
        <mat-form-field class="orbitax-search-field w-p-100" appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search..." formControlName="searchText">
        </mat-form-field>
      </div>
      <div class="select-deselect-wrapper quick-link-items flex flex-row">
        <a (click)="selectAllContact()">
          Select All
        </a>
        <div class="toolbar-separator h-n-15 m-lr-5"></div>
        <a (click)="deselectAllContact()">
          Deselect All
        </a>
      </div>
      <div class="w-p-100 share-items-wrapper">
        <div *ngFor="let userGroup of contacts['userGroups']">
          <div class="each-item-container" *ngIf="userGroup.visibleItemCount>0">
            <div class="alphabate">{{userGroup.key}}</div>
            <div *ngFor="let user of userGroup.users">
              <div *ngIf="user.isVisible"
                   [ngClass]="user.isChecked ? 'each-item dirty' : 'each-item'">

                <div class="chk-list-label">
                  <div class="chk-list-img">
                    <mat-checkbox [(ngModel)]="user.isChecked"
                                  particleAnalytics
                                  analyticsCategory="share-items-user"
                                  analyticsAction="checkbox"
                                  (change)="onContactCheckBoxChange($event, user)"
                    ></mat-checkbox>
                  </div>
                  <div class="chk-list-img">
                    <ngx-stored-gravatar [hideOnlineStatus]="false" [email]="user.user.email" [name]="user.user.name"
                                         [size]="40">
                    </ngx-stored-gravatar>
                  </div>
                  <div class="chk-list-text">
                    <div>{{ user.user.name }}</div>
                    <div> {{user.user.email}} </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cc-modal-table-cell">
      <h3 class="component-heading ">Active Services</h3>
      <div [formGroup]="serviceFilterForm">
        <mat-form-field class="orbitax-search-field w-p-100" appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search..." formControlName="searchText">
        </mat-form-field>
      </div>
      <mat-list>
        <mat-list-item *ngFor="let item of expertServicesModels">
          <mat-checkbox *ngIf="item.isVisible"
                        (change)="onCheckBoxChange($event, item)"
                        [matTooltip]="item.description">
            {{ item.title }}
          </mat-checkbox>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>
